import React from 'react';
import { Button } from 'antd';

function FormExpand({ isSystemSetting, formExpand, setFormExpand }) {
  const handleFormExpand = () => {
    setFormExpand(!formExpand);
    if (isSystemSetting) {
      const settingHeader = document.getElementById('project-form-title');
      const forMask = document.getElementById('value-driver-mask');
      settingHeader.style.display = formExpand ? 'flex' : 'none';
      forMask.style.marginTop = formExpand ? '' : '1.563rem';
    }
  };
  return (
    <div className="value-driver-form-expand-wrapper">
      <Button onClick={handleFormExpand}>
        <span
          className={`appkiticon icon-${
            formExpand ? 'minimize' : 'expand'
          }-fill a-text-orange`}
        />
      </Button>
    </div>
  );
}

export default FormExpand;
